// Mock data for wirkaufendeinlaptop.de

export const companyInfo = {
  name: "wirkaufendeinLaptop.de",
  email: "ankauf@wirkaufendeinlaptop.de",
  phone: "+49 4519 3105207",
  address: "Ahornweg 3, 23869 Elmenhorst, Deutschland",
};

export const manufacturers = [
  { 
    name: "Dell",
    // Simple text-based logo with brand styling
    displayName: "DELL"
  },
  { 
    name: "Lenovo",
    displayName: "lenovo"
  },
  { 
    name: "HP",
    displayName: "HP"
  },
  { 
    name: "Apple",
    displayName: ""  // Will use Apple icon
  },
  { 
    name: "Fujitsu",
    displayName: "FUJITSU"
  },
];

export const benefits = [
  {
    title: "Professionelle Abwicklung",
    description: "Schnelle und unkomplizierte Prozesse speziell für Unternehmen",
    icon: "Briefcase",
  },
  {
    title: "Sichere Logistik",
    description: "Deutschlandweite Abholung mit versicherten Transportpartnern",
    icon: "Truck",
  },
  {
    title: "Zertifizierte Datenlöschung",
    description: "DSGVO-konforme Datenlöschung mit Zertifikat für jedes Gerät",
    icon: "ShieldCheck",
  },
  {
    title: "Faire Ankaufspreise",
    description: "Transparente Bewertung und attraktive Preise für Ihre Hardware",
    icon: "Euro",
  },
  {
    title: "IT-Remarketing Expertise",
    description: "Über 10 Jahre Erfahrung im professionellen Hardware-Ankauf",
    icon: "Award",
  },
  {
    title: "Schnelle Auszahlung",
    description: "Zügige Zahlung nach erfolgter Abholung und Prüfung",
    icon: "Zap",
  },
];

export const processSteps = [
  {
    step: 1,
    title: "Anfrage stellen",
    description: "Füllen Sie unser B2B-Anfrageformular aus und laden Sie Ihre Geräteliste hoch",
    icon: "FileText",
  },
  {
    step: 2,
    title: "Gerätebewertung",
    description: "Wir bewerten Ihre Geräte anhand von Hersteller, Modell und Zustand",
    icon: "Search",
  },
  {
    step: 3,
    title: "Ankaufsangebot",
    description: "Sie erhalten ein transparentes Ankaufsangebot für Ihre Geräte",
    icon: "FileCheck",
  },
  {
    step: 4,
    title: "Abholung, Datenlöschung & Auszahlung",
    description: "Deutschlandweite Abholung, zertifizierte Datenlöschung und schnelle Auszahlung",
    icon: "CheckCircle2",
  },
];

export const trustFactors = [
  {
    title: "500+",
    subtitle: "Zufriedene Firmenkunden",
  },
  {
    title: "50.000+",
    subtitle: "Angekaufte Geräte",
  },
  {
    title: "100%",
    subtitle: "DSGVO-konform",
  },
  {
    title: "10+",
    subtitle: "Jahre Erfahrung",
  },
];

export const images = {
  heroBackground: "https://images.unsplash.com/photo-1553877522-43269d4ea984",
  businessMeeting: "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a",
  laptopWorkspace: "https://images.unsplash.com/photo-1558478551-1a378f63328e",
  modernWorkspace: "https://images.unsplash.com/photo-1706735733956-deebaf5d001c",
  multipleLaptops: "https://images.unsplash.com/flagged/photo-1576697010739-6373b63f3204",
  dataSecurity: "https://images.unsplash.com/photo-1614064641938-3bbee52942c7",
  securityShield: "https://images.unsplash.com/photo-1667372283545-1261fb5c427a",
  cybersecurity: "https://images.pexels.com/photos/5380618/pexels-photo-5380618.jpeg",
};

// Mock form submission
export const submitLeadForm = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submitted:", formData);
      resolve({ success: true, message: "Ihre Anfrage wurde erfolgreich übermittelt" });
    }, 1000);
  });
};
